import base from '../dr-base'
import drLauncher from './dr-launcher.vue'
const schema = {
  $Type: 'dr-launcher',
  name: 'Launcher',
  group: 'Launchers',
  icon: 'stream',
  ...base,
  properties: {
    ...base.properties
  }
}


export default {
  schema,
  component: drLauncher
}